import React from 'react'

import PropTypes from 'prop-types'

import './steps.css'

const Steps = (props) => {
  return (
    <div className="steps-container1 thq-section-padding">
      <div className="steps-max-width thq-section-max-width">
        <div className="steps-container2 thq-grid-2">
          <div className="steps-section-header">
            <h2 className="thq-heading-2">
              Discover the Power of Our Products
            </h2>
            <p className="thq-body-large">
              Feel the power of professional and courteous service with Camos IT Solutions. Whether you need a new POS installed or a new SSD, we've got you covered. Give us a call for a free quote or for on-the-spot IT support today.
            </p>
            <div className="steps-actions">
            <a
                  href="https://book.squareup.com/appointments/x3k8budz1ctfgx/location/T1GPHC1Z2QE6W/services"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="pricing-text85 thq-body-small"
                >
                  <button className="thq-button-animated thq-button-filled steps-button">
              <span className="thq-body-small">
                  Book with us Now</span>
              </button>
              </a>
            </div>
          </div>
          <div className="steps-container3">
            <div className="steps-container4 thq-card">
              <h2 className="thq-heading-2">{props.step1Title}</h2>
              <span className="steps-text14 thq-body-small">
                {props.step1Description}
              </span>
              <label className="steps-text15 thq-heading-3">01</label>
            </div>
            <div className="steps-container5 thq-card">
              <h2 className="thq-heading-2">{props.step2Title}</h2>
              <span className="steps-text17 thq-body-small">
                {props.step2Description}
              </span>
              <label className="steps-text18 thq-heading-3">02</label>
            </div>
            <div className="steps-container6 thq-card">
              <h2 className="thq-heading-2">{props.step3Title}</h2>
              <span className="steps-text20 thq-body-small">
                {props.step3Description}
              </span>
              <label className="steps-text21 thq-heading-3">03</label>
            </div>
            <div className="steps-container7 thq-card">
              <h2 className="thq-heading-2">{props.step4Title}</h2>
              <span className="steps-text23 thq-body-small">
                {props.step4Description}
              </span>
              <label className="steps-text24 thq-heading-3">04</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Steps.defaultProps = {
  step4Title: 'Feedback & Follow-up',
  step4Description:
    'Share your experience with Camos IT Solutions and receive follow-up assistance to ensure satisfaction.',
  step3Title: 'Implementation & Support',
  step1Description:
    'Schedule a free security checkup to assess your IT needs and cybersecurity vulnerabilities.',
  step2Title: 'Service Customization',
  step1Title: 'Initial Consultation',
  step2Description:
    'Tailor IT repair, cybersecurity, or business consulting services to meet your specific requirements.',
  step3Description:
    'Receive expert assistance in implementing solutions and ongoing support for all your tech needs.',
}

Steps.propTypes = {
  step4Title: PropTypes.string,
  step4Description: PropTypes.string,
  step3Title: PropTypes.string,
  step1Description: PropTypes.string,
  step2Title: PropTypes.string,
  step1Title: PropTypes.string,
  step2Description: PropTypes.string,
  step3Description: PropTypes.string,
}

export default Steps
